import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, Output, EventEmitter, Input, OnDestroy } from '@angular/core';
import { WbService } from '../wb.service';
import { WsService } from '../../utils/network/ws.service';
import { TranslateService } from 'ng2-translate/ng2-translate';
import {environment} from '../../../environments/environment';
import {WhiteBoardComponent} from "../white-board.component";
import {SessionManagerService} from "../services/session/session-manager.service";
import { UserTypeManagerService, UserType } from "../services/usertype/user-type-manager.service";
import {LayoutManagerService} from "../services/layout/layout-manager.service";
import {PermissionsManagerService} from "../services/permissions/permissions-manager.service";
declare var $;
declare var videojs;

import {LogService} from "../services/log/log.service";

@Component({
  selector: "dskl-wb-media",
  templateUrl: 'media-wb.component.html',
  inputs: ["board"], 
  outputs: ["change", "onCurrentState"]
})
export class MediaWbComponent extends WhiteBoardComponent implements OnDestroy {

    translatePageName() {
    this.translate.get('WB_PAGE_NAME.PAGE_MEDIA').subscribe((res: string) => { this.pageName = res; });
  }
  onCurrentPageState(state, pageId){
  }
  getWbType(){
    return this.pageName;
  }
  pageName = " Дъска за медия файлове"
  player;
  constructor(protected log: LogService,  private userTypeManager: UserTypeManagerService, protected wbService: WbService, private wsService: WsService, private translate: TranslateService, protected sessionManager: SessionManagerService , protected layoutServiceManager: LayoutManagerService, protected permissionsManager: PermissionsManagerService){
    super(log, wbService, sessionManager,layoutServiceManager, permissionsManager);
}
  onResize(){
    
  }
  getEnvironment(){
    return environment;
  }
  onReady() {
  
   
    this.translatePageName();
  }
  onState(state, pageId) {
     if (this.userTypeManager.getType()==UserType.TEACHER)return;
    console.log("Got state ", state);
    var self = this;
    this.changing = true;
    switch (state.type) {
      case "fileloaded":
        
        this.setupPlayer(state.value.filename); break;
      case "seeked": this.player.currentTime(state.value.position); break;
      case "pause": this.player.pause(); this.player.currentTime(state.value.position); break;
      case "play": this.player.currentTime(state.value.position); this.player.play(); break;
    }
    setTimeout(function () {
      self.changing = false;
    }, 100);
  }
  initPlayer = false;
  private init() {
    this.player = videojs("player", { inactivityTimeout: 0, language: environment.medialng });

    this.player.on("play", function (e) {
      self.changed("play", self.player.currentTime());
    })
    this.player.on("pause", function (e) {
      self.changed("pause", self.player.currentTime());
    })
    var self = this;
    this.player.on("seeked", function (e) {
      self.changed("seeked", self.player.currentTime());
    });
  }
 
  setupPlayer(filename) {
    var self = this;

    if (self.player) {
      try {

        self.player.dispose();
      } catch (error) { console.log(error) }
    }
    this.initPlayer = false;
    setTimeout(function () {
      self.initPlayer = true;
      setTimeout(function () {
      self.init();
      self.player.src(filename);
      $("#player").parent().css("height","80%");
      
      $("#player").css("position","unset");
    }, 0);
    }, 0);

    
  }
  onViewReady() {


  }

  changing = false;
  private changed(type, position, filename = null) {
    if (this.userTypeManager.getType()==UserType.STUDENT)return;
    if (this.changing) {
      console.log("Currently we are updating so no update")
      return;
    }

    this.emitChanged({ type: type, value: { position: position, filename: filename } });
  }

  showFile(f) {
    console.log("Loaded file f", f)
   
    //videojs("player", {inactivityTimeout:0, language: "bg"});
    var self = this;
    //environment.contentsBackendUrl + environment.contentsFileMapping + f.path  +f.page + "." + f.type
    var path;
    if (f.path){
    var parts = f.path.split("/");
    path = parts[0]  
    }
    var filename = environment.contentsBackendUrl + environment.contentsFileMapping +f.nameUuid+"."+f.type
     this.changed("fileloaded", 0, filename);
    this.setupPlayer(filename);

  }
}




// WEBPACK FOOTER //
// /app/src/app/wb/media/media-wb.component.ts